module.exports = __webpack_public_path__ + "img/befce295be920940dd2865e9aec465ce.svg";